module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3940587dc72db305766e163b38ea3a7b.png";